module.exports = __webpack_public_path__ + "static/img/about-main.1ff1e4c0.png";